import OrdemServicoListaPagamentos from "../../../ordem-servicos/add-ordem-servico/components/ordem-servico-lista-pagamentos.component";

const OrcamentoServicoListaPagamentos = ({
  id,
  orcamentoServico,
  setOrcamentoServico,
  listaOrcamentoServicoPagamentos,
  setListaOrcamentoServicoPagamentos,
  condicaoPagamentoList,
  gerarPagamentos,
  setGerarPagamentos,
  condicaoSelecionada,
  setCondicaoSelecionada,
  condicaoPagParcelaList,
  setCondicaoPagParcelaList,
  meioPagamentoList,
  meiosPagamentoCliente,
  orcamentoServicoEntity,
  meioPagamentoSelecionado,
  setMeioPagamentoSelecionado,
  listaOrcamentoServicoProdutos,
  setListaOrcamentoServicoProdutos,
  setAcrescimoPagamento,
  produto,
  setProduto,
  isFechado,
}) => {
  const ordemServicoMapped = orcamentoServico
    ? { ...orcamentoServico, totalOrdemServico: orcamentoServico.totalOrcamentoServico }
    : orcamentoServico;

  if (orcamentoServicoEntity) {
    orcamentoServicoEntity.totalOrdemServico = orcamentoServicoEntity.totalOrcamentoServico;
  }

  const handleSetOrdemServico = (entity) => {
    setOrcamentoServico({ ...entity });
  };

  return (
    <OrdemServicoListaPagamentos
      id={id}
      ordemServico={ordemServicoMapped}
      setOrdemServico={handleSetOrdemServico}
      listaOrdemServicoPagamentos={listaOrcamentoServicoPagamentos}
      setListaOrdemServicoPagamentos={setListaOrcamentoServicoPagamentos}
      condicaoPagamentoList={condicaoPagamentoList}
      gerarPagamentos={gerarPagamentos}
      setGerarPagamentos={setGerarPagamentos}
      condicaoSelecionada={condicaoSelecionada}
      setCondicaoSelecionada={setCondicaoSelecionada}
      condicaoPagParcelaList={condicaoPagParcelaList}
      setCondicaoPagParcelaList={setCondicaoPagParcelaList}
      meioPagamentoList={meioPagamentoList}
      meiosPagamentoCliente={meiosPagamentoCliente}
      ordemServicoEntity={orcamentoServicoEntity}
      meioPagamentoSelecionado={meioPagamentoSelecionado}
      setMeioPagamentoSelecionado={setMeioPagamentoSelecionado}
      listaOrdemServicoProdutos={listaOrcamentoServicoProdutos}
      setListaOrdemServicoProdutos={setListaOrcamentoServicoProdutos}
      setAcrescimoPagamento={setAcrescimoPagamento}
      produto={produto}
      setProduto={setProduto}
      isFechado={isFechado}
    />
  );
};

export default OrcamentoServicoListaPagamentos;
